import { moment } from "../../../config/vue/plugins/moment";

export const futureServiceDateHelpers = () => {
  return [
    { text: "em 1 semana", date: fromNow(1, "week") },
    { text: "em 2 semanas", date: fromNow(2, "weeks") },
    { text: "em 3 semanas", date: fromNow(3, "weeks") },
    { text: "em 4 semanas", date: fromNow(4, "weeks") },
    { text: "em 6 semanas", date: fromNow(6, "weeks") },
    { text: "em 8 semanas", date: fromNow(8, "weeks") },
    { text: "em 3 meses", date: fromNow(3, "months") },
    { text: "em 4 meses", date: fromNow(4, "months") },
    { text: "em 5 meses", date: fromNow(5, "months") },
    { text: "em 6 meses", date: fromNow(6, "months") },
    { text: "em 7 meses", date: fromNow(7, "months") },
    { text: "em 8 meses", date: fromNow(8, "months") },
    { text: "em 9 meses", date: fromNow(9, "months") },
    { text: "em 1 ano", date: fromNow(1, "year") },
  ];
};

const fromNow = (count, timespan) => {
  const current = moment().startOf("month");

  const time = current.add(count, timespan);

  return time.format("YYYY-MM");
};
